import { useEffect, useState } from "react";
import API from "../api";

function Inventory() {
  const [data, setData] = useState([]);
  const [stockInputs, setStockInputs] = useState({});
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = () => {
    API.get("inventory/get-inventory/")
      .then(res => setData(res.data));
  };

  const handleInputChange = (sheetId, value) => {
    setStockInputs({
      ...stockInputs,
      [sheetId]: value
    });
  };

  const handleAddStock = async (sheetId) => {
    const quantity = stockInputs[sheetId];

    if (!quantity || quantity <= 0) return;

    try {
      setLoadingId(sheetId);

      await API.post("inventory/add-stock/", {
        sheet_id: sheetId,
        quantity: quantity
      });

      setStockInputs({
        ...stockInputs,
        [sheetId]: ""
      });

      fetchInventory();

    } catch (err) {
      alert("Error updating stock");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div>
      <h2 className="mb-4">Inventory Management</h2>

      <div className="card shadow-sm">
        <div className="card-body">

          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>Name</th>
                <th>Thickness (mm)</th>
                <th>Stock</th>
                <th style={{ width: "250px" }}>Add Stock</th>
              </tr>
            </thead>

            <tbody>
              {data.map(sheet => (
                <tr key={sheet.id}>
                  <td>{sheet.name}</td>
                  <td>{sheet.thickness_mm}</td>

                  <td>
                    <span className={`badge fs-6 ${
                      sheet.stock_sheets < 5
                        ? "bg-danger"
                        : sheet.stock_sheets < 10
                        ? "bg-warning text-dark"
                        : "bg-success"
                    }`}>
                      {sheet.stock_sheets}
                    </span>
                  </td>

                  <td>
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Qty"
                        value={stockInputs[sheet.id] || ""}
                        onChange={(e) =>
                          handleInputChange(sheet.id, e.target.value)
                        }
                      />

                      <button
                        className="btn btn-primary"
                        onClick={() => handleAddStock(sheet.id)}
                        disabled={loadingId === sheet.id}
                      >
                        {loadingId === sheet.id ? "..." : "Add"}
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>

        </div>
      </div>
    </div>
  );
}

export default Inventory;
